import { Archive, BadgeCheck, EyeOff, Sparkles, UploadCloud } from "lucide-react";
import { PageHeader } from "../../components/PageHeader";

export function InstructionsPage() {
  return (
    <div className="grid gap-8">
      <PageHeader
        eyebrow="Client Instructions"
        title="How Your Memory Media Vault Works"
        subtitle="A simple guide for reviewing guest uploads and keeping your Memory Hub elegant."
      />
      <section className="ivory-card rounded-lg p-6 sm:p-8">
        <p className="text-lg leading-8 text-ktd-rich">
          Your Memory Media Vault stores extra photos and videos for your Memory Hub without overwhelming the main page.
          Guests can upload photos and videos through your Memory Hub upload link. All uploads go into a pending review
          area first.
        </p>
        <p className="mt-5 text-lg leading-8 text-ktd-rich">
          You decide which memories are approved, hidden, not approved, or featured on the Memory Hub.
        </p>
        <p className="mt-5 text-lg leading-8 text-ktd-rich">
          Approved media may appear in your full gallery. Featured media may appear on your main Memory Hub page.
        </p>
        <p className="mt-5 text-lg leading-8 text-ktd-rich">
          Your storage is connected to your own Cloudflare account. Please keep your billing active and your login
          information safe to maintain long-term access.
        </p>
      </section>
      <section className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {[
          { icon: UploadCloud, title: "Pending", copy: "Uploaded but not reviewed." },
          { icon: BadgeCheck, title: "Approved", copy: "Can appear in the full approved gallery." },
          { icon: EyeOff, title: "Hidden", copy: "Stored privately and not public." },
          { icon: Sparkles, title: "Featured", copy: "Appears on the curated Memory Hub section." },
        ].map((item) => {
          const Icon = item.icon;
          return (
            <article key={item.title} className="ivory-card rounded-lg p-6">
              <Icon className="size-8 text-[#D94A16]" />
              <h2 className="mt-5 text-xl font-extrabold">{item.title}</h2>
              <p className="mt-2 text-sm leading-6 text-ktd-muted">{item.copy}</p>
            </article>
          );
        })}
      </section>
      <section className="rounded-lg bg-ktd-black p-6 text-white shadow-luxe sm:p-8">
        <Archive className="size-8 text-ktd-softGold" />
        <h2 className="mt-5 font-display text-3xl font-bold">Memory Hub only</h2>
        <p className="mt-4 leading-7 text-white/66">
          This system is only for Memory Hubs. It is not required for RSVP Hubs, and Archive Hubs only need it when they
          connect to a Memory Hub with hosted photos or videos.
        </p>
      </section>
    </div>
  );
}
